import React, { useState, useRef } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import HeaderInner from "../../Components/HeaderInner";
import EntertainmentCarosle from "../../Components/EntertainmentCarosle";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import axios from "../../axios";
import { object, string } from "yup";
import { useEffect } from "react";
import SpaLoader from "../../Components/Loaders/SpaLoader";
import { useTranslation } from "react-i18next";
import ReactGA from "react-ga4";
import Title from "../../new-components/title/Title";
import NewFooter from "../../NewFooter";
import { phoneFormat } from "../../constants/api";
import PhoneInputComponent from "../../Components/PhoneInputComponent";
import { useBusinessNameContext } from "../../context/BusinessName";
import CustomBusinessServiceLoader from "../../Components/Loaders/CustomBusinessServiceLoader";
import { trackMenuItemViewed, trackOrderSubmitted } from "../../utils/mixpanel";
import useMixpanel from "../../hooks/useMixpanel";
import LocationVerificationModal from "../../Components/LocationVerificationModal";
import PaymentOptionList from "../../Components/PaymentOptionList";
import { normalizePaymentMethods } from "../../utils/paymentMethods";
import { isClosedNow } from "../../utils/availability";
import ClosedNotice from "../../new-components/closed-badge/ClosedNotice";

function EntertainmentDetail() {
  const { room_uuid, tour_desk_uuid, id } = useParams();
  const { track } = useMixpanel();
  const loaderRef = useRef(null);
  const { businessName, setBusinessName } = useBusinessNameContext();
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const new_design = localStorage.getItem("new_design");
  const [showLocationModal, setShowLocationModal] = useState(false);
  const theme = new_design === "true";
  const handleClose = (En_name) => {
    setShow(false);
    ReactGA.event({
      category: "Close popup Entertainment detail ",
      action: "Click",
      value: `Entertainment detail: ${En_name}`,
    });
  };
  const handleShow = (En_name) => {
    setShow(true);
    ReactGA.event({
      category: "Open popup Entertainment detail ",
      action: "Click",
      value: `Entertainment detail: ${En_name}`,
    });
  };
  const [headerImage, setHeaderImage] = useState();
  const [header_title, setheader_title] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [tourDeskClosed, setTourDeskClosed] = useState(false);
  const [description, setDescription] = useState();
  const [description_2, setDescription_2] = useState();

  const { t } = useTranslation();

  const [entertainmentPrice, setEntertainmentPrice] = useState();
  const [entertainmentTime, setEntertainmentTime] = useState();
  const [entertainmentHeader, setEntertainmentHeader] = useState();
  const [entertainmentActivites, setEntertainmentActivites] = useState();
  const [description_21, setDescription_21] = useState();
  const [entertainmentActivites_1, setEntertainmentActivites_1] = useState();
  const [activities_format, setactivities_format] = useState("");
  const [description_2_format, setdescription_2_format] = useState("");

  const [entertainment, setEntertainment] = useState({
    name: "",
    phone: "",
    email: "",
    number_adults: "",
    number_childs: "",
    note: "",
    category_id: "",
    redirect_url: `https://${window.location.host}/${room_uuid}/EntertainmentCallback`,
  });

  const navigate = useNavigate();

  let userSchema = object({
    name: string(),
    phone: string(),
    email: string(),
    number_adults: string(),
    number_childs: string(),
    note: string(),
    category_id: string(),
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setEntertainment((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const [name, setName] = useState("");
  const [img, setImg] = useState("");
  const [errName, setErrName] = useState("");
  const [errPhone, setErrPhone] = useState("");
  const [phoneWithoutCode, setPhoneWithoutCode] = useState("");
  const [errEmail, setErrEmail] = useState("");
  const [errnumberAdults, setErrnumberAdults] = useState("");
  const [paymentUrl, setPaymentUrl] = useState("");
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  const [selectedOnlinePaymentMethod, setSelectedOnlinePaymentMethod] =
    useState("credit card");
  const checkValEmail =
    entertainment.email.length >= 0 &&
    !/\S+@\S+\.\S+/.test(entertainment.email);

  const checkInputs = () => {
    if (!entertainment.name.trim()) {
      setErrName("The name field is required.");
    } else {
      setErrName("");
    }

    if (checkValEmail) {
      setErrEmail("The email must be a valid email address.");
    } else {
      setErrEmail("");
    }
    if (phoneWithoutCode.trim() === "") {
      setErrPhone("The phone field is required.");
    } else {
      setErrPhone("");
    }
    if (entertainment.number_adults == "") {
      setErrnumberAdults(t("The number adults field is required."));
    } else {
      setErrnumberAdults("");
    }
  };
  const submitEntertainmentOrder = async () => {
    setIsDisabled(true);

    try {
      const answer = await userSchema.validate(entertainment);

      const formData = new FormData();

      formData.append("category_id", String(answer.category_id || ""));
      formData.append("name", answer.name || "");
      formData.append("phone", answer.phone || "");
      formData.append("email", answer.email || "");
      formData.append("number_of_adults", String(answer.number_adults || ""));
      formData.append("number_of_childs", String(answer.number_childs || ""));
      formData.append("note", answer.note || "");

      formData.append("payment_method", selectedPaymentMethod);

      const res = await axios.post(
        `/${room_uuid}/tour-desk/${tour_desk_uuid}/order`,
        formData,
        {
          headers: {
            lang,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      ReactGA.event({
        category: "Book service entertainment",
        action: "Click",
        value: `Entertainment: ${name}`,
      });

      if (res.data.success) {
        trackOrderSubmitted({
          order_id: res.data.data?.orderId || "",
          order_number: res.data.data?.orderNumber || "",
          service_type: "entertainment",
          order_source: localStorage.getItem("room_type") || "room",
          items_count: 1,
          subtotal: 0,
          tax: 0,
          delivery_fee: 0,
          other_fees: 0,
          total_amount: 0,
          is_external_service: false,
        });

        if (res?.data?.data?.payment_url) {
          if (res.data.data.is_embedded) {
            setPaymentUrl(res.data.data.payment_url);
          } else {
            window.location.href = res.data.data.payment_url;
          }
        } else {
          navigate(`/${room_uuid}/TourDeskOrderPlaced`, {
            state: {
              metadata: {
                res: res.data.data,
              },
            },
          });
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsDisabled(false);
    }
  };
  const handleBook = () => {
    checkInputs();

    if (
      entertainment.name.trim() &&
      !checkValEmail &&
      phoneWithoutCode.trim() !== "" &&
      entertainment.number_adults
    ) {
      setShowLocationModal(true);
    }
  };

  const handleLocationVerified = () => {
    setShowLocationModal(false);
    submitEntertainmentOrder();
  };
  const lang = sessionStorage.getItem("lang");

  useEffect(() => {
    trackMenuItemViewed({
      item_id: id,
      item_name: entertainment?.name || "",
      category_name: "Entertainment",
    });
  }, [id, entertainment]);

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      axios
        .get(`/${room_uuid}/tour-desk/${tour_desk_uuid}/category/${id}`, {
          headers: {
            lang: lang,
          },
        })
        .then((res) => {
          if (res.data.status === false || res.data.success === false) {
            navigate(`/${room_uuid}/qr-scan`);
          } else {
            const data = res.data.data;
            const category = data?.Category || {};
            const methods = normalizePaymentMethods(
              data?.tour_desk?.payment_methods
            );
            setPaymentMethods(methods);
            setSelectedPaymentMethod(methods[0]?.payment_method || "");
            setTourDeskClosed(
              isClosedNow(data?.tour_desk) || isClosedNow(data)
            );

            setHeaderImage([category?.image] || []);
            setheader_title(data?.title || "");
            setdescription_2_format(category?.description2_format || "");
            setactivities_format(category?.activities_format || "");
            setImg(category?.image || "");

            setDescription(category?.description || "");
            setDescription_21(category?.description_2 || "");
            setDescription_2(
              category?.description_2
                ?.split(/\r\n/)
                .filter((line) => line.trim() !== "")
            );
            setEntertainmentActivites_1(category?.activities || "");
            setEntertainmentActivites(
              category?.activities
                ?.split(/\r\n/)
                .filter((line) => line.trim() !== "")
            );
            setName(category?.name || "");
            setEntertainmentPrice(category?.price || "");
            setEntertainmentTime(category?.time || "");
            setEntertainmentHeader(category?.name || "");
            setEntertainment((prev) => ({
              ...prev,
              category_id: category?.id || "",
            }));
          }
          setLoading(false);
        })
        .catch((err) => {
          if (err?.response.status == 404) {
            // navigate(`/not-found`);
          }
        });
    };
    getData();
  }, []);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, []);
  const handleLoad = () => {
    // Hide the loading view when the iframe is loaded
    if (loaderRef.current) {
      loaderRef.current.style.display = "none"; // Hide the loader by setting display to 'none'
      loaderRef.current.style.visibility = "hidden"; // Hide the loader by setting visibility to 'hidden'

      loaderRef.current.remove();
    }
  };

  return (
    <div className={theme ? "food pb-0" : ""}>
      {theme ? (
        <Title title={header_title} />
      ) : (
        <HeaderInner headerName={header_title} />
      )}
      <main className="home-main  pad-top-0 back-fe">
        {loading ? (
          <CustomBusinessServiceLoader
            businessName={businessName}
            loader={"spa"}
          />
        ) : (
          <>
            <EntertainmentCarosle arr={[{ id: 1, image: img ?? "" }]} />
            {tourDeskClosed && <ClosedNotice />}

            <div className="padd-div f-16">
              <h3 style={{ fontSize: "16px", marginTop: "10px" }}>
                {entertainmentHeader}
              </h3>
              {description && (
                <>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: description?.replaceAll("\n", "</br>"),
                    }}
                  ></div>
                  <br />
                </>
              )}
              {entertainmentPrice && (
                <>
                  <strong>{t("Price")} :</strong>
                  <div className="d-flex ">
                    {/* <span className="mx-1">{`${currency} `}</span> */}
                    <div
                      dangerouslySetInnerHTML={{
                        __html: entertainmentPrice?.replaceAll("\n", "</br>"),
                      }}
                    ></div>
                  </div>
                  <br />
                </>
              )}

              {description_2 ? (
                description_2_format == "list" ? (
                  <div className={lang == "AR" ? "mr-3" : "ml-3"}>
                    <ul className="ent_list">
                      {description_2?.map((item, i) => {
                        return (
                          <li key={i} className={i == 0 ? "list_head" : ""}>
                            {item}
                          </li>
                        );
                      })}
                    </ul>

                    <br />
                  </div>
                ) : (
                  <div className="mt-2 mb-2">
                    {/* <strong className=" mb-1"></strong> */}
                    <p className="des2_title">
                      {description_21?.split("\r\n\r\n")[0]}
                    </p>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: description_21
                          ?.split("\r\n\r\n")[1]
                          ?.replaceAll("\n", "</br>"),
                      }}
                    ></div>
                    <br />
                  </div>
                )
              ) : null}

              {entertainmentActivites ? (
                activities_format == "list" ? (
                  <div className={lang == "AR" ? "mr-3" : "ml-3"}>
                    <ul className="ent_list">
                      {entertainmentActivites?.map((item, i) => {
                        return (
                          <li key={i} className={i == 0 ? "list_head" : ""}>
                            {item}
                          </li>
                        );
                      })}
                    </ul>
                    <br />
                  </div>
                ) : (
                  <div className=" mt-2 mb-2">
                    {/* <span className="mx-1">{`${currency} `}</span> */}
                    <p className="des2_title">
                      {entertainmentActivites_1?.split("\r\n\r\n")[0]}
                    </p>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: entertainmentActivites_1
                          ?.split("\r\n\r\n")[1]
                          ?.replaceAll("\n", "</br>"),
                      }}
                    ></div>
                    <br />
                  </div>
                )
              ) : null}

              {entertainmentTime && (
                <>
                  <strong>{t("Timing")}:</strong>
                  <br />
                  <div className="d-flex ">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: entertainmentTime?.replaceAll("\n", "</br>"),
                      }}
                    ></div>
                  </div>
                  <br />
                </>
              )}
            </div>

            <div className="padd-div text-center">
              <Button
                className="reg-btn large more-pad font-dark"
                onClick={() => handleShow(name)}
                disabled={tourDeskClosed}
              >
                {t("Book")}
              </Button>
            </div>
          </>
        )}
        <Modal
          show={show}
          onHide={handleClose}
          className={`custom-width  ${theme ? "food-modal" : ""}`}
        >
          <Modal.Body>
            <button
              type="button"
              className="button close-pop"
              onClick={() => handleClose(name)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24.054"
                height="24.625"
                viewBox="0 0 24.054 24.625"
              >
                <defs></defs>
                <path
                  id="Icon_ionic-ios-close-circle"
                  data-name="Icon ionic-ios-close-circle"
                  className="cls-50"
                  d="M15.4,3.375A12.17,12.17,0,0,0,3.375,15.687,12.17,12.17,0,0,0,15.4,28,12.17,12.17,0,0,0,27.429,15.687,12.17,12.17,0,0,0,15.4,3.375Zm3.047,16.77L15.4,17.025l-3.047,3.12a.913.913,0,0,1-1.307,0,.959.959,0,0,1,0-1.338l3.047-3.12-3.047-3.12a.959.959,0,0,1,0-1.338.913.913,0,0,1,1.307,0L15.4,14.35l3.047-3.12a.913.913,0,0,1,1.307,0,.966.966,0,0,1,0,1.338l-3.047,3.12,3.047,3.12a.966.966,0,0,1,0,1.338A.9.9,0,0,1,18.449,20.145Z"
                  transform="translate(-3.375 -3.375)"
                ></path>
              </svg>
            </button>
            <div className="body-container">
              <div className="img-pnl">
                <img className="" src={img} />
              </div>
              <div className="content-pnl">
                <div className="top">
                  <p className="title text-start">{name}</p>
                  {/* <p className="">Timing</p> */}
                </div>
                <div className="input-pnl">
                  <Row className="justify-content-center">
                    <Col xs="12">
                      <Form.Group
                        className="mb-3 dark-placeholder i-f-small"
                        controlId="formBasicname"
                      >
                        <Form.Control
                          type="text"
                          inputMode="numeric"
                          pattern="[0-9]*"
                          placeholder={t(`No. Adults`)}
                          name="number_adults"
                          value={entertainment.number_adults}
                          onChange={(e) => {
                            const value = e.target.value;

                            if (/^\d*$/.test(value)) {
                              setEntertainment((prev) => ({
                                ...prev,
                                number_adults: value,
                              }));
                            }
                          }}
                        />
                      </Form.Group>
                      {errnumberAdults != "" && (
                        <span className="err_msg">
                          {t(`${errnumberAdults}`)}
                        </span>
                      )}
                    </Col>
                    <Col xs="12">
                      <Form.Group
                        className="mb-3 dark-placeholder i-f-small"
                        controlId="formBasicname"
                      >
                        <Form.Control
                          type="text"
                          inputMode="numeric"
                          pattern="[0-9]*"
                          placeholder={t(`No. Children (Optional)`)}
                          name="number_childs"
                          value={entertainment.number_childs}
                          onChange={(e) => {
                            const value = e.target.value;

                            if (/^\d*$/.test(value)) {
                              setEntertainment((prev) => ({
                                ...prev,
                                number_childs: value,
                              }));
                            }
                          }}
                        />
                      </Form.Group>
                    </Col>
                    <Col xs="12">
                      <Form.Group
                        className="mb-3 dark-placeholder i-f-small"
                        controlId="formBasicname"
                      >
                        <Form.Control
                          type="text"
                          placeholder={t(`Your Name`)}
                          name="name"
                          value={entertainment.name}
                          onChange={handleInputChange}
                        />
                      </Form.Group>
                      {errName != "" && (
                        <span className="err_msg">{t(`${errName}`)}</span>
                      )}
                    </Col>
                  </Row>
                  <Form.Group className="mb-3 dark-placeholder i-f-small w-100">
                    <PhoneInputComponent
                      value={entertainment.phone}
                      onChange={(phone, country) => {
                        setEntertainment((prev) => ({
                          ...prev,
                          phone,
                        }));

                        const numberWithoutCode = phone.slice(
                          country?.dialCode?.length || 0
                        );

                        setPhoneWithoutCode(numberWithoutCode);
                      }}
                    />
                  </Form.Group>
                  {errPhone != "" && (
                    <span className="err_msg" style={{ marginLeft: "-100px" }}>
                      {t(`${errPhone}`)}
                    </span>
                  )}
                  <Row>
                    <Col xs="12">
                      <Form.Group
                        className="mb-3 dark-placeholder i-f-small"
                        controlId="formBasicname"
                      >
                        <Form.Control
                          type="email"
                          placeholder={t(`Your Email`)}
                          name="email"
                          value={entertainment.email}
                          onChange={handleInputChange}
                        />
                      </Form.Group>
                      {errEmail != "" && (
                        <span className="err_msg">{t(`${errEmail}`)}</span>
                      )}
                    </Col>
                    <Col xs="12">
                      <Form.Group className="mb-3 dark-placeholder i-f-small w-100">
                        <Form.Control
                          as="textarea"
                          placeholder={t(`Your Notes (Optional)`)}
                          name="note"
                          value={entertainment.note}
                          onChange={handleInputChange}
                          style={{ height: "106px" }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </div>

                {paymentMethods.length > 0 && !paymentUrl && (
                  <div style={{ textAlign: "center" }}>
                    <div className="mb-4">
                      <div className="full-heading payment flex">
                        <h2>{t("Payment Options")}</h2>
                      </div>

                      <PaymentOptionList
                        selected={selectedPaymentMethod}
                        setSelected={setSelectedPaymentMethod}
                        methods={paymentMethods}
                        setSelectedOnlinePaymentMethod={
                          setSelectedOnlinePaymentMethod
                        }
                      />
                    </div>
                  </div>
                )}
                <div className="spacer-40"></div>
                {!paymentUrl && (
                  <div className="padd-div text-center mb-2 ">
                    <Button
                      className="reg-btn book fw-normal"
                      onClick={handleBook}
                      disabled={isDisabled || tourDeskClosed}
                    >
                      {t(`Book`)}
                    </Button>
                  </div>
                )}
                {paymentUrl && (
                  <div className="payment-iframe">
                    <div
                      className="d-flex justify-content-center m-5 "
                      ref={loaderRef}
                    >
                      {/* <div className="home_loader"> */}
                      <div
                        className="loader"
                        style={{
                          borderColor: "lightgray",
                          borderRightColor: "#000000",
                        }}
                      ></div>
                      {/* </div>sss */}
                    </div>
                    <iframe
                      loading="lazy"
                      src={paymentUrl}
                      width="100%"
                      title="Payment Preview"
                      scrolling="no"
                      onLoad={handleLoad}
                    ></iframe>
                  </div>
                )}
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </main>
      {theme && <NewFooter />}
      <LocationVerificationModal
        show={showLocationModal}
        room_uuid={room_uuid}
        theme={theme}
        onVerified={handleLocationVerified}
      />
    </div>
  );
}
export default EntertainmentDetail;
